// Get count of DC node in a service
export const getDatabaseDCCount = (database) => {
  const dataCentreInstances = database?.instances?.filter((instance) => instance?.type === 'DC');
  return dataCentreInstances?.length || 0;
};
